import { extractApiError } from 'utils';
import { createAsyncThunk } from '@reduxjs/toolkit';
import {
  changePasswordRequest,
  createNotificationRequest,
  editFinanceRequest,
  editUserRequest,
  getDoctorFinancesRequest,
  getDoctorsRequest,
  getDoctorVisitsRequest,
  getFinancesRequest,
  getMeRequest,
  getNotificationRequest,
  getPatientVisitsRequest,
  getUserRequest,
  getUsersRequest,
  logInRequest,
  LoginRequestType,
  restorePasswordRequest,
  signUpRequest,
  SignUpRequestType,
  verifyResetRequest,
} from 'api';
import { LsKeys, routes } from 'enums';
import { authActions } from 'state';

export const getFinances = createAsyncThunk(
  'finance/get',
  async (query: any, { rejectWithValue, getState, dispatch }) => {
    try {
      const res = await getFinancesRequest(query);

      console.log('loaded data finance');
      console.log(res.data);

      return res.data;
    } catch (error: any) {
      return rejectWithValue(extractApiError(error));
    } finally {
      console.log('finally');
    }
  },
);

export const getDoctor = createAsyncThunk(
  'user/get',
  async (id: any, { rejectWithValue, getState, dispatch }) => {
    try {
      const res = await getUserRequest(id);

      return res.data;
    } catch (error: any) {
      return rejectWithValue(extractApiError(error));
    } finally {
      console.log('finally');
    }
  },
);

export const editUser = createAsyncThunk(
  'user/patch',
  async ({ data, id }: any, { rejectWithValue, getState, dispatch }) => {
    try {
      const res = await editUserRequest(id, data);

      return res.data;
    } catch (error: any) {
      return rejectWithValue(extractApiError(error));
    } finally {
      console.log('finally');
    }
  },
);

export const editFinance = createAsyncThunk(
  'finance/patch',
  async ({ data, id }: any, { rejectWithValue, getState, dispatch }) => {
    try {
      const res = await editFinanceRequest(id, data);

      return res.data;
    } catch (error: any) {
      return rejectWithValue(extractApiError(error));
    } finally {
      console.log('finally');
    }
  },
);

/**
 * A near-duplicate of `doctorThunk.getDoctorVisits`, dispatched by nothing.
 *
 * Renamed with its twin all the same. It still declared the type prefix
 * `visits/get`, which is the collision that was just removed there: had anyone
 * ever wired this one up, its response would have been written into the
 * PATIENT visits slice as well as the provider one, and the provider page's
 * pagination would have started reading somebody else's list again.
 */
export const getDoctorVisits = createAsyncThunk(
  'doctorVisits/get',
  async (query: any, { rejectWithValue, getState, dispatch }) => {
    try {
      const res = await getDoctorVisitsRequest(query);

      return res.data;
    } catch (error: any) {
      return rejectWithValue(extractApiError(error));
    } finally {
      console.log('finally');
    }
  },
);

export const getDoctorFinances = createAsyncThunk(
  'finances/get',
  async (query: any, { rejectWithValue, getState, dispatch }) => {
    try {
      const res = await getDoctorFinancesRequest(query);

      return res.data;
    } catch (error: any) {
      return rejectWithValue(extractApiError(error));
    } finally {
      console.log('finally');
    }
  },
);

export const financeThunk = {
  getFinances,
  editFinance,
  getDoctor,
  editUser,
  getDoctorVisits,
  getDoctorFinances,
};
